<template>
      <div class="mask" >
       	<div class="alert">
            <div class="alertmain">
                <img class="close" @click="close"  src="static/images/close.png" />
                <div class="alertcontent">
                    <div>
                      {{alertinfo.content}}
                    </div>
                </div>
                <div class="alertbtn">
                  <p class="big" @click="close">OK</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import { mapGetters,mutations } from 'vuex'
  export default {

    data() {
       return {
          name:'alert'
       }
    },
    computed: {
      ...mapGetters([
        'alertinfo',
      ]),
    },
    methods:{
      close(){
         this.$store.commit('SET_ALERT',{type:'error',content:'',showis:false})
      }
    }
  }
</script>

<style scoped>
  .alert{
    padding: 0 1.25rem 0;
    height: 10rem;
    margin: calc(50vh - 6rem) auto 0;
    max-width: 800px;
  }
  .close{
    width: 1rem;
    height: 1rem;
    display: block;
    float: right;
    margin-bottom: 0.625rem;
  }
  .alertmain{
    clear: both;
    background-color: #293549 ;
    padding: 1rem 0.9375rem 1.25rem;
  }
  .alerthead{
    height: 2.5rem;
    overflow: hidden;
  }
  .alerthead img{
    display: block;
    float: left;
    margin-right: 0.5rem;
    height: 2.5rem;
  }
  .alerthead p span{
    display: block;
    font-size: 0.75rem;

    line-height: 0.75rem;
    color: #7B95B8;
  }
  .alerthead p .alertinfo{
    font-size: 0.875rem;
    line-height: 1.125rem;
    margin-bottom:0.5rem;
    color: #FFFFFF;
    text-align: center;
    font-family: "SemiBold";
  }
  .alertcontent{
    margin-top: 1.625rem;
    text-align: center;
    padding:0.9375rem 0.625rem ;

    font-size: 0.875rem;
    color: #404D5E ;
    line-height: 1rem;
    margin-bottom: 0.75rem;
  }
  .alertcontent p{
     font-size: 0.875rem;
     margin-top: 0.25rem;
     /* color: #FFFFFF; */
     line-height: 1rem;
     text-align: center;
  }
  .alertcontent .alerttitle{
    font-size: 0.9375rem;
    font-weight: 600;
    margin-bottom: 1rem;
  }
  .big{
    width: 70%;
    line-height: 2.3rem;
    text-align: center;
    height: 2.3rem;
    background-color: #3BE487;
    color: #FFFFFF;
    font-size: 0.875rem;
    font-family: "SemiBold";
    margin: 1.25rem auto 0.4rem;
  }
  .small{
    text-align: center;
    font-weight: 500;
    text-decoration: underline;
    color: #7B95B8;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Alert.vue